
import { Base } from '../base-component';

import './product-filter.component.scss';

import * as $ from 'jquery';

export class ProductFilter extends Base {

	currentFilter: string = "";
	filterItem: JQuery<HTMLElement>;
	slideRunner: JQuery<HTMLElement>;
	dropdown: JQuery<HTMLElement>;

	filterJson: any;
	productJson: any;

	constructor(element: Element) {

		super(element);

	}

	init() {

		let parseData = jsonData;
		this.filterJson = parseData.filters;
		this.productJson = parseData.products;

		this.filterItem = $('.product-filter__item');
		this.slideRunner = $('.product-filter__slide-runner');
		this.dropdown = $('.product-filter__dropdown');

		$(document).ready(() => {

			this.currentFilter = this.filterItem.first().data('filter');
			this.moveSlideRunner(this.filterItem.first());

		});

	}

	bindEvents() {

		this.dropdown.click((e) => {
			$('.product-filter__wrapper').toggleClass('product-filter__wrapper--open');
		});

		$(document).on('click', '.product-filter__item', (e) => {
			let filter = $(e.currentTarget);
			this.currentFilter = filter.data('filter');

			this.moveSlideRunner(filter);

			$('.product-filter__dropdown-value-text').text(this.currentFilter);
			$('.product-filter__wrapper').removeClass('product-filter__wrapper--open');
		});

		window.addEventListener('resize', this.debounce(() => {

			let currentFilterItem = $(`.product-filter__item[data-filter='${this.currentFilter}']`);
			this.moveSlideRunner(currentFilterItem);

		}, 250, false));
		$(document).on('click', '.product-filter__item', (e) => {
			let filter = $(e.currentTarget).data('filter');
			this.filterProducts(filter);
		});
	}

	filterProducts(tag) {
		$('.product-card').addClass("product-card--hide");
		let filtered = this.productJson.filter((prod) => {
			return prod.tags.indexOf(tag) > -1;
		});

		let removed = this.productJson.filter((prod) => {
			return prod.tags.indexOf(tag) == -1;
		});

		setTimeout(() => {
			this.productJson.forEach(el => {
				$('.product-card[data-id="' + el.id + '"]').appendTo(".product-card-wrapper");
			});

			filtered.forEach(el => {
				$('.product-card[data-id="' + el.id + '"]').removeClass("product-card--filtered").removeClass("product-card--hide");
			});

			removed.forEach(el => {
				$('.product-card[data-id="' + el.id + '"]').addClass("product-card--filtered");
				$('.product-card[data-id="' + el.id + '"]').appendTo(".product-card-wrapper");
			});
		}, 200);
	}



	moveSlideRunner(filter: JQuery<HTMLElement>) {

		let filterPositionLeft = filter.position().left;
		let filterWidth = filter.width();

		this.slideRunner
			.width(0)
			.css('left', `${filterPositionLeft + 35}px`)
			.show()
			.delay(350)
			.width(filterWidth);

	}

	debounce(func, wait, immediate) {
		let timeout;
		return function () {
			let context = this, args = arguments;
			let later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			let callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

}



// WEBPACK FOOTER //
// ./components/product-filter/product-filter.component.ts